<template>
  <modal titulo="Odin - Editar Processamento de Ato" id="odin-processamento-ato"
         :fechar="true" @close="close" :loading="loading"  >
    <template #default>
      <div id="dados-principais">
        <card titulo="Dados Gerais">
          <div class="row gutters-xs ato">
            <v-input
              v-if="odin.atoMatricula.dataAto"
              class="col-4"
              label="Data do Ato"
              type="date"
              v-model="form.atoMatricula.dataAto"
              :error="validation.dataAto"
            />
            <v-input
              v-if="odin.atoMatricula.negociosId && odin.atoMatricula.negociosId.length"
              class="col-12"
              label="Negócio Jurídico"
              type="v-multi-select"
              :options="negocios"
              v-model="form.atoMatricula.negociosId"
              :error="validation.negociosId"
            />

            <tag-list class="form-group col-12" v-if="(form.atoMatricula.negociosId || []).includes(2)"
                      titulo="Criar Restrições" :tags="restricoes" :list1="form.atoMatricula.criacaoRestricoes" />

            <template v-if="(form.atoMatricula.negociosId || []).includes(5)">
              <tag-list class="form-group col-12"
                        titulo="Cancelar Restrições" :tags="restricoes" :list1="form.atoMatricula.cancelamentoRestricoes" />

              <v-input
                class="col-12"
                label="Código do ato cancelado"
                type="text"
                v-model="form.atoMatricula.cancelamentoAto"
                :error="validation.cancelamentoAto"
              />
            </template>


          </div>
        </card>
        <card  v-if="editarIndicadorReal"
               titulo="Indicador Real">
          <card-table class="table-borderless">

            <thead>
            <tr>
              <th width="200px">Campo</th>
              <th class="pr-0">Valor</th>
              <th width="30px"></th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="campo in camposEditados" :key="campo">
              <td>{{getInput(campo).nome}}</td>
              <td>
                <v-input class="mb-0" v-model="form.indicadorReal[campo]" :input-props="{precision : {min : 2, max : 10}}"
                         :small="true" :type="getInput(campo).type" :options="getInput(campo).options"></v-input>
              </td>
              <td class="text-right">
                <div class="ato-action">
                  <a href="" @click.prevent="removeInput(campo)" class="icon"><i class="fa fa-times"></i></a>
                </div>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <td class="pl-0" style="vertical-align: top;">
                <v-input class="mb-0" v-model="novoForm.campo"
                         :small="true" type="select" :options="camposIndicador"></v-input>
              </td>
              <td class="px-0">
                <v-input class="mb-0" v-model="novoForm.valor" :input-props="{precision : {min : 2, max : 10}}"
                         :small="true" :type="getInput(novoForm.campo).type" :options="getInput(novoForm.campo).options"></v-input>
              </td>
              <td class="text-right pr-0" style="vertical-align: top;">
                <div class="ato-action" v-if="novoForm && novoForm.campo">
                  <a href="" @click.prevent="addInput()" class="btn btn-outline-secondary btn-xs">
                    <i class="fa fa-plus"></i>
                  </a>
                </div>
              </td>
            </tr>
            </tfoot>
          </card-table>
        </card>
        <card
          titulo="Envolvidos">
          <card-table class="table-borderless">
            <thead>
            <tr>
              <th class="pr-0" style="width: 260px;">Nome</th>
              <th class="pr-0" style="width: 260px;">CPF/CNPJ</th>
              <th class="pr-0" style="width: 220px;">Papel</th>
              <th class="pr-0" style="width: 100px;">Fração</th>
              <th width="20px">
                <a href="" @click.prevent="add()" class="btn btn-outline-secondary btn-xs">
                  <i class="fa fa-plus"></i>
                </a>
              </th>
            </tr>
            </thead>

            <tbody>

            <tr v-for="(campo, idx) in form.envolvidos" :key="idx">
              <td>
                <v-input type="text" v-model="campo.nome" />
              </td>
              <td>
                <v-input type="text" v-model="campo.documento" />
              </td>
              <td>
                <v-input
                  type="v-multi-select"
                  :options="papeis"
                  v-model="campo.papelId" />
              </td>
              <td>
                <v-input type="currency"
                         @blur="verificarFracao(campo, idx)"
                         :input-props="{precision : {min : 2, max : 10}}"
                         v-model="campo.fracao" />
              </td>
              <td class="text-center">
                <div class="ato-action">
                  <a href="" @click.prevent="remove(idx)" class="icon"><i class="fa fa-times"></i></a>
                </div>
              </td>
            </tr>

            <tr v-if="!form.envolvidos || !form.envolvidos.length">
              <td colspan="100%" class="p-0">
                <div class="alert alert-outline-secondary alert-sm mb-0">
                  Nenhum envolvido cadastrado
                </div>
              </td>
            </tr>

            </tbody>

          </card-table>

        </card>
        <card titulo="Informações da Transação" v-if="possuiInformacoesTransacao">
          <div class="row gutters-xs ato">
            <v-input
              v-if="possuiValorTransacao"
              class="col-6"
              label="Valor do Negócio/Alienação"
              type="currency"
              :input-props="{precision : {min : 2, max : 10}}"
              v-model="form.atoMatricula.valorTransacao"
            />
            <v-input
              v-if="possuiMoedaTransacao"
              class="col-6"
              label="Moeda Utilizada"
              type="text"
              v-model="form.atoMatricula.moedaTransacao"
            />
            <v-input
              v-if="possuiDataTransacao"
              class="col-6"
              label="Data da Alienação"
              type="date"
              v-model="form.atoMatricula.dataTransacao"
            />
          </div>
        </card>
      </div>
    </template>

    <template #footer>
      <button class="btn btn-outline-secondary mr-auto" type="button" @click.prevent="close(false)">
        Fechar
      </button>
      <v-button
        class="btn-outline-primary"
        :run="salvar"
        :popover="true"
      >
        Atualizar
      </v-button>
    </template>
  </modal>
</template>

<script setup>

import {computed, onMounted, reactive, ref} from 'vue';
import Modal from '@/components/Modal.vue';
import Card from '@/components/Layout/components/Card.vue';
import OdinBusiness from "@/views/Odin/OdinBusiness";
import FrontBusiness from "@/business/FrontBusiness";
import TagList from "@/components/Form/TagList.vue";
import business from "@/views/Administracao/modulos/tipo-servico/business";
import CardTable from "@/components/Layout/components/CardTable.vue";

const props = defineProps({
  odin: Object,
});

const form = reactive({
  ...props.odin,
  envolvidos: [...(props.odin.envolvidos || [])],
})

const novoForm = reactive({
  campo: '',
  valor: ''
});

const validation = ref({
  codigo: '',
  cancelamentoAto: ''
});

onMounted(() => {
  possuiValorTransacao.value = !!props.odin.atoMatricula.valorTransacao;
  possuiMoedaTransacao.value = !!props.odin.atoMatricula.moedaTransacao;
  possuiDataTransacao.value = !!props.odin.atoMatricula.dataTransacao;

  tratarOdin();
  loading.value = false;
});

function tratarOdin() {

  if (form.atoMatricula) {
    form.atoMatricula.negociosId = (form.atoMatricula?.negociosId || []).filter(x => ![null, undefined, ''].includes(x));
  }

  form.envolvidos.forEach(e => {
    e.papelId = (e.papelId || []);
    if (e.papelId.includes(0) && !e.papelId.includes(2)) {
      e.papelId = e.papelId.filter(x => ![0].includes(x))
      e.papelId.push(2)
    }
    e.papelId = e.papelId.filter(x => ![null, undefined, ''].includes(x))
  })

  const camposMoeda = camposIndicador.filter(campo => campo.type === 'currency');

  if (form.indicadorReal) {
    for (const campo of camposMoeda) {
      const valor = form.indicadorReal[campo.id];

      if (valor != null && valor !== '') {
        const normalizado = String(valor).replace(',', '.');

        const convertido = parseFloat(normalizado);

        if (!isNaN(convertido)) {
          form.indicadorReal[campo.id] = convertido;
        }
      }
    }
  }

  if (form.atoMatricula.valorTransacao != null && form.atoMatricula.valorTransacao !== '') {
    const normalizado = String(form.atoMatricula.valorTransacao).replace(',', '.');
    const convertido = parseFloat(normalizado);
    if (!isNaN(convertido)) {
      form.atoMatricula.valorTransacao = convertido;
    }
  }
}


const loading = ref(true);

const possuiValorTransacao = ref(false);
const possuiMoedaTransacao = ref(false);
const possuiDataTransacao = ref(false);

const negocios = (OdinBusiness.getNegocioJuridico());

const restricoes = (business.restricoes());
const camposIndicador = (OdinBusiness.getCamposIndicador());
const todosPapeis = OdinBusiness.getPapelSimplificado();

const papeis = computed(() => {
  const negociosSelecionados = form.atoMatricula.negociosId || [];

  return todosPapeis.filter(papel =>
    papel.negocio.length === 0 ||
    papel.negocio.some(id => negociosSelecionados.includes(id))
  );
})

const camposEditados = computed(() => {
  const validIds = camposIndicador.map(c => c.id);
  return Object.keys(form.indicadorReal || {}).filter(key => validIds.includes(key));});

const editarIndicadorReal = computed(() => {
  return (form.atoMatricula.negociosId || []).includes(4) || (form.atoMatricula.negociosId || []).includes(0)
})

const possuiInformacoesTransacao = computed(() => {
  return possuiValorTransacao.value || possuiMoedaTransacao.value || possuiDataTransacao.value;
})

const close = (retorno) => {
  FrontBusiness.closeModal(retorno);
}

const verificarFracao = (envolvido, i) => {
  if (envolvido.fracao > 100) {
    form.envolvidos[i].fracao = 100;
  }
}

const salvar = async () => {
  let ok = true;
  if ((form.atoMatricula.negociosId || []).includes(5)) {
    if (!form.atoMatricula.cancelamentoAto) {
      validation.value.cancelamentoAto = 'Campo Obrigatório';
    }
    if (!form.atoMatricula.cancelamentoRestricoes.length) {
      FrontBusiness.showError("", "É necessário informar quais restrições estão sendo canceladas.");
      ok = false;
    }
  }
  if ((form.atoMatricula.negociosId || []).includes(2)) {
    if (!form.atoMatricula.criacaoRestricoes.length) {
      FrontBusiness.showError("", "É necessário informar quais restrições estão sendo criadas.");
      ok = false;
    }
  }

  (form.envolvidos || []).forEach((envolvido) => {
    envolvido.papelId =  (envolvido.papelId || []).filter(papel => papel);
    const papeisInvalidos = (envolvido.papelId || []).filter(
      papel => !(papeis.value || []).map(e => e.id).includes(papel)
    );

    if (papeisInvalidos.length) {
      let nomes = papeisInvalidos.map(p => {
        let papel = (todosPapeis || []).find(e => e.id === p);
        return `${papel.id} - ${papel.nome}`
      })
      FrontBusiness.showError("", `${ envolvido.nome } possui papeis não permitidos: ${ nomes.join(', ') }`);
      ok = false;
    }
  })

  if (ok) {
    form.envolvidos = (form.envolvidos || []).map((envolvido) => {
      envolvido.papelId = (envolvido.papelId || []).filter(papel => papel);
      delete envolvido.papel;
      envolvido.percentual = `${envolvido.fracao}%`
      return envolvido;
    });
    delete form.atoMatricula.negocios;
    if (!(form.atoMatricula.negociosId || []).includes(5)) {
      delete form.atoMatricula.cancelamentoAto;
      delete form.atoMatricula.cancelamentoRestricoes;
    }
    if (!(form.atoMatricula.negociosId || []).includes(2)) {
      delete form.atoMatricula.criacaoRestricoes;
    }
    if (!editarIndicadorReal) {
      form.indicadorReal = {};
    } else {
      for (let campo of camposIndicador.filter(e => e.type === 'currency')) {
        if (form.indicadorReal[campo.id]) {
          form.indicadorReal[campo.id] = form.indicadorReal[campo.id].toFixed(2).replace('.', ',')
        }
      }
      for (const campo of ['unidadeAutonoma', 'possuiGeorreferenciamento']) {
        if (![undefined, null, ''].includes(form.indicadorReal[campo])) {
          form.indicadorReal[campo] = form.indicadorReal[campo] ? 1 : null;
        }
      }
    }
    if (!!form.atoMatricula.valorTransacao) {
      form.atoMatricula.valorTransacao = Number(form.atoMatricula.valorTransacao).toFixed(2).replace('.', ',');
    }
    if (form.atoMatricula.cancelamentoAto) {
      form.atoMatricula.cancelamentoAto = (form.atoMatricula.cancelamentoAto || '')?.split(', ');
    }
    close(form)
  }
}

const add = () => {
  form.envolvidos.push({fracao: 0});
}

const remove = (idx) => {
  form.envolvidos.splice(idx, 1);
}

const getInput = (id) => {
  return (camposIndicador?.find(c => c.id == id) || {})
}

const removeInput = (key) => {
  const indicadores = Object.assign({}, form.indicadorReal);
  delete indicadores[key];
  form.indicadorReal = indicadores;
}

const addInput = () => {
  const indicadores = Object.assign({}, form.indicadorReal);
  indicadores[novoForm.campo] = novoForm.valor;
  form.indicadorReal = indicadores;
  novoForm.campo = '';
  novoForm.valor = '';
}

</script>
